// @ts-nocheck
import StoreCartReducer, { StoreCartActions } from "@store/Framework/Store/Pages/Cart/StoreCartReducer";
import StoreCheckoutReviewAndSubmitReducer, {
    StoreCheckoutReviewAndSubmitActions,
} from "@store/Framework/Store/Pages/CheckoutReviewAndSubmit/StoreCheckoutReviewAndSubmitReducer";
import { StoreOrderApprovalActions } from "@store/Framework/Store/Pages/OrderApprovalDetails/StoreOrderApprovalDetailsReducer";
import StoreOrderDetailsReducer, {
    StoreOrderDetailsActions,
} from "@store/Framework/Store/Pages/OrderDetails/StoreOrderDetailsReducer";
import RequestRmaPageReducer, {
    StoreRequestRmaPageActions,
} from "@store/Framework/Store/Pages/RequestRma/RequestRmaPageReducer";
import StoreListsReducer, { StoreListsActions } from "@store/Framework/Store/Pages/StoreLists/StoreListsReducer";
import StoreListsDetailsReducer, {
    StoreListsDetailsActions,
} from "@store/Framework/Store/Pages/StoreListsDetails/StoreListsDetailsReducer";
import { combineReducers } from "redux";

const pagesReducers = {
    requestRma: RequestRmaPageReducer,
    checkoutReviewAndSubmit: StoreCheckoutReviewAndSubmitReducer,
    orderDetails: StoreOrderDetailsReducer,
    storeLists: StoreListsReducer,
    storeListsDetails: StoreListsDetailsReducer,
    cart: StoreCartReducer,
};

export type StorePagesActions =
    | StoreOrderApprovalActions
    | StoreRequestRmaPageActions
    | StoreCheckoutReviewAndSubmitActions
    | StoreOrderDetailsActions
    | StoreListsActions
    | StoreListsDetailsActions
    | StoreCartActions;

const pageReducer = combineReducers(pagesReducers as any);
export default pageReducer;
